import eventBus from '@/plugins/eventBus';
import internals from '../config/internals';
import {
  getRefreshToken, getToken, saveRefreshToken, saveToken,
} from './LocalStorageService';

function refleshToken() {
  return new Promise((resolve) => {
    async function useFetch() {
      try {
        const refreshToken = getRefreshToken();
        const token = getToken();
        const response = await fetch(
          'api/account/auth/refresh-token',
          {
            method: 'post',
            body: JSON.stringify({
              refreshToken,
            }),
            headers: new Headers({
              'x-api-key': internals.x_api_key,
              'content-type': 'application/json',
              accept: '*/*',
              authorization: `Bearer ${token}`,
            }),
          },
        );
        const body = await response.json();

        saveRefreshToken(body);
        saveToken(body);
        resolve(body);
      } catch (err) {
        eventBus.$emit('confirm-login', { err });
      }
    }
    useFetch();
  });
}

export default refleshToken;
